import axios from "axios";

import { __API_BASE_URL__ } from "@/shared/config";
import { setAccessToken } from "@/shared/config/orval/makeRequest";
import { getRefreshToken } from "@/shared/lib/getRefreshToken";

export const refreshToken = async () => {
    const refreshToken = getRefreshToken();
    if (!refreshToken) {
        return Promise.reject(new Error("No refresh token available"));
    }

    const response = await axios({
        method: "POST",
        url: `${__API_BASE_URL__}/api/internal/refresh_token`,
        data: { refresh_token: refreshToken },
    });
    const { access_token, refresh_token } = response.data.data;
    if (access_token && refresh_token) {
        setAccessToken(access_token);
        localStorage.setItem("refreshToken", refresh_token);
    }
};
